<template>
    <div class="public_container personnel_add_wrap" v-loading="loading">
        <div class="returnNavBar">
            <ReturnNavBar title="返回" :isTitleNormal="true"> </ReturnNavBar>
        </div>
        <div class="mobile_container" :class="isApply ? 'form_disabled' : ''">
            <CustomFormMobile
                ref="personnel_custom_form"
                :field_list="formInfoList"
                :form_detail="formData"
                :is_form_module="true"
                @submit-form="submitFormData"
                :pk_id="1"
                v-if="dataLoaded"
            />
        </div>
        <div class="add_footer_wrap">
            <van-button round block type="info" :disabled="isApply" @click="handleClickConfirm">{{
                isApply ? "已申请，等待审核中" : "申请加入"
            }}</van-button>
        </div>
    </div>
</template>

<script>
import { getCompanyFormFields, userEditByInvite, GetUserInviteInfo, getUserDetail } from "@/api";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
import CustomFormMobile from "@/components/mComponents/CustomFormMobile";
import { decryptAES } from "@/utils/index";
import { mapState } from "vuex";
export default {
    name: "mobileInvitUser",
    components: { ReturnNavBar, CustomFormMobile },
    data() {
        return {
            isApply: false, // 是否已经申请
            loading: false,
            formInfoList: [],
            formData: null,
            dataLoaded: false,
            btnDisabled: false,
            phone: "",
            company_id: "",
            invite_id: "",
        };
    },
    computed: {
        ...mapState(["userInfo"]),
    },
    created() {
        if (this.$route.query) {
            this.company_id = this.$route.query.company_id;
            this.phone = this.$route.query.phone;
            this.invite_id = this.$route.query.invite_id ? decryptAES(this.$route.query.invite_id) : "";
        }
        this._getFromFields();
    },
    methods: {
        //表单字段获取
        _getFromFields() {
            this.loading = true;
            getCompanyFormFields({
                field_form: "users",
                company_id: this.company_id,
            })
                .then((res) => {
                    if (res.code === 200) {
                        const newFormInfoList = res.data
                            .filter((item) => item.extend.is_form_show) // 过滤第一级
                            .map((item) => {
                                if (item._child) {
                                    // 过滤掉 child.is_form_show_can_close 为 false 的项
                                    item._child.forEach((child) => {
                                        if (child.field_key != "name" && child.field_key != "phone") {
                                            child.is_required = 0; // 将 is_required 字段改为 0
                                        }
                                        if (child.field_type == "table") {
                                            if (child._child && child._child.length) {
                                                child._child.forEach((tableChild) => {
                                                    tableChild.is_required = 0; // 将 is_required 字段改为 0
                                                });
                                            } else {
                                                child._child = [];
                                            }
                                        }
                                    });
                                    const filteredChildren = item._child.filter((child) => child.extend.is_form_show);
                                    return {
                                        ...item,
                                        _child: filteredChildren, // 返回新的对象，包含过滤后的子项
                                    };
                                }
                                return item; // 如果没有 _child，直接返回原项
                            });

                        this.formInfoList = newFormInfoList;
                        this.formData = {
                            phone: {
                                phone_type: "1",
                                prefix: "+86",
                                value: this.phone,
                            },
                        };
                        this.getUserInviteInfo();
                    } else {
                        this.$message.error(res.message);
                    }
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        // 获取用户是否填写过邀请信息
        getUserInviteInfo() {
            GetUserInviteInfo({ user_id: this.userInfo.id }).then((res) => {
                if (res.code === 200) {
                    if (res.data.has_invited) {
                        // 编辑过了
                        this.isApply = true;
                        let formInfoList = this.formInfoList.map(item=> {
                            if (item._child) {
                                item._child.forEach((child) => {
                                    child.field_disabled = true
                                })
                            }
                            return item
                        })
                        this.formInfoList = formInfoList
                        getUserDetail({
                            user_id: this.userInfo.id,
                        }).then((res) => {
                            if (res.code === 200) {
                                var detail = res.data;
                                if(detail.gender && detail.gender.value == 0) {
                                    detail.gender = {
                                        text: '',
                                        value: ""
                                    }
                                }
                                this.formData = detail
                                this.dataLoaded = true;
                            } else {
                                this.$message.error(res.message);
                            }
                        });
                    } else {
                        this.dataLoaded = true;
                    }
                } else {
                    this.dataLoaded = true;
                }
            });
        },
        handleClickConfirm() {
            this.$refs.personnel_custom_form.handleClickPublish();
        },
        // 提交
        submitFormData(customForm) {
            if (customForm) {
                const data = {
                    ...customForm,
                    user_id: this.userInfo.id,
                    invite_id: this.invite_id,
                };
                userEditByInvite(data).then((res) => {
                    if (res.code === 200) {
                        this.$toast({
                            message: "申请成功",
                            type: "success",
                            duration: 1000,
                            onClose: () => {
                                this.isApply = true;
                            },
                        });
                    } else {
                        this.isApply = false;
                    }
                });
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.personnel_add_wrap {
    .mobile_container {
        padding: 10px 0;
        &.form_disabled .custom_form_wrap {
            position: relative;
        }
        &.form_disabled .custom_form_wrap:before {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            z-index: 10000;
            content: " ";
        }
    }
    .add_footer_wrap {
        padding: 5px 16px;
        background-color: #f7f8fa;

        .van-button {
            border-radius: 8px;
            height: 38px;
            background-color: rgba(41, 144, 240, 1);
            border-color: rgba(41, 144, 240, 1);
        }
    }
}
</style>
